import { z } from 'zod';


export const forgotSchema = z.object({
    email: z.string().min(1, 'Email is required').pipe(z.email('Invalid email')),
});

export type ForgotFormData = z.infer<typeof forgotSchema>;
